// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"2a0fda71","169":"a736f401","449":"2a1d8dd5","469":"06b7ff40","543":"4af37313"}[chunkId] + ".chunk.js";
};